import { CommonModule } from '@angular/common';
import {
	ChangeDetectionStrategy,
	Component,
	ElementRef,
	HostBinding,
	inject,
	Input,
	NgModule,
} from '@angular/core';

import { UserPublicInfo } from '@reach/interfaces/user/user.interface';

import { ReachImgModule } from '~app-ui/cdk/directives';
import { CdnModule } from '~app-ui/cdk/pipes';

@Component({
	// eslint-disable-next-line @angular-eslint/prefer-standalone
	standalone: false,
	selector: 'reach-user-thumbnail',
	templateUrl: './user.component.html',
	styleUrls: ['./user.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReachUserThumbnailComponent {
	private readonly elementRef = inject<ElementRef<HTMLElement>>(ElementRef);

	@HostBinding('class.use-initials')
	@Input()
	public useInitials = true;

	@Input()
	public set user(user: UserPublicInfo | undefined) {
		const oldUrl = this.url;
		this._user = user;
		this.url = this.cleanUrl(this.user?.thumbnailUrl ?? '');
		if (oldUrl !== this.url && this.url !== '') {
			this.loading = true;
			this.showImage = true;
		}
	}

	public get user(): UserPublicInfo | undefined {
		return this._user;
	}

	public url = '';

	private _user?: UserPublicInfo;

	@HostBinding('class.loading')
	public loading = true;

	@HostBinding('class.show-image')
	public showImage = false;

	@HostBinding('class.show-initials')
	public get showInitials(): boolean {
		return !this.showImage;
	}

	public get initials(): string {
		return (this.user?.fullName ?? '')
			.split(' ')
			.map((s) => s.substring(0, 1))
			.join('')
			.substring(0, 1)
			.toUpperCase();
	}

	public get nativeElement(): HTMLElement {
		return this.elementRef.nativeElement;
	}

	public onLoad(img: HTMLImageElement): void {
		this.loading = false;

		if (img.height < 3 || img.width < 3) {
			this.onError();
		}
	}

	public onError(): void {
		this.loading = false;
		this.showImage = false;
	}

	private cleanUrl(url?: string): string {
		return (url ?? '').trim();
	}
}

@NgModule({
	declarations: [ReachUserThumbnailComponent],
	imports: [CommonModule, ReachImgModule, CdnModule],
	exports: [ReachUserThumbnailComponent],
})
export class ReachUserThumbnailModule {}
